import AppOrdersIndex from "./order.vue";
import AppOrdersList from "./list/list.vue";
import AppOrdersItem from "./item/item.vue";

const routes = [
  {
    path: "/order",
    component: AppOrdersIndex,
    meta: {
      auth: {
        roles: "order.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "order.index",
        component: AppOrdersList,
        meta: {
          auth: {
            roles: "order.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "order.create",
        component: AppOrdersItem,
        meta: {
          auth: {
            roles: "order.create",
            redirect: { name: "order.index" }
          }
        }
      },
      {
        path: ":id",
        name: "order.edit",
        component: AppOrdersItem,
        meta: {
          auth: {
            roles: "order.update",
            redirect: { name: "order.index" }
          }
        }
      }
    ]
  }
];

export default routes;
